import {useEffect, useContext, useState} from "react";

import { useParams } from "react-router-dom";

import useTranslatedTitle from "./use-translated-title";
import stringHasValue from "../../utils/string-has-value";
import useStatus from "../generic/hooks/use-status/use-status";
import AnalyticsAppContext from "../global-layout/master-layout/analytics-app-context";
import masterTranslationsContext from "../global-layout/master-layout/master-translations-context";
import menuContext from "../global-layout/top-bar/menu-context";


const defaultArray = [];
const defaultFunction = () => {}
const usePageStandardFunctionality = ({
  stringGroups = defaultArray,
  menuTitle = "",
  menuHref = "/",
  service,
  dataParams,
  pageName
}) => {
  const {
    stringsStatus,
    requestLanguageGroups,
  } = useContext(masterTranslationsContext);

  const {
    analyticsPageEvent
  } = useContext(AnalyticsAppContext) ?? {};

  useEffect(() => {
    if (typeof analyticsPageEvent === "function" && stringHasValue(pageName)) {
      analyticsPageEvent(pageName, dataParams);
    }
  },[analyticsPageEvent, pageName, dataParams])

  const [data, setData] = useState();
  const {
    status:dataStatus,
    setSavingStatus:loading,
    setErrorStatus:error,
    setResetStatus:clearStatus,
  } = useStatus({saving:true});

  useEffect(() => {
    const load = async() => {
      try {
        loading();
        const pageData = await service.pageLoad(dataParams);
        setData(pageData);
        clearStatus()
      } catch (e) {
        error(e);
      }

    }
    if (typeof service?.pageLoad === "function") {
      load();
    }
    // eslint-disable-next-line -- Prevent multiple API calls on load
  },[dataParams])

  /*If we want to have the main menu deal be a navigate action
    which plays nicer with our SPA without the flicker
    then we need to do some additional work. I think we could put an onclick on the menuTitleObject
    , prevent default and then call navigate. */
  const {
    setMenuTitleObj = defaultFunction,
    setHubOrProgram = defaultFunction
  } = useContext(menuContext);
  const {programId, hubId} = useParams();
  useEffect(() => {
    const pId = parseInt(programId);
    const hId = parseInt(hubId);
    if (isNaN(pId) && isNaN(hId)) {
      setHubOrProgram();
    }
  },[hubId, programId, setHubOrProgram]);

  useEffect(() => {
    requestLanguageGroups([...stringGroups, "shared"]);
  },[stringGroups,requestLanguageGroups]);
  useEffect(() => {
    setMenuTitleObj({
      text: menuTitle,
      href: menuHref
    });
  }, [menuTitle, menuHref, setMenuTitleObj]);

  useTranslatedTitle({ menuTitle });

  return {
    stringsStatus,
    dataStatus,
    data,
    setMenuTitleObj
  }
}

export default usePageStandardFunctionality;